export default {
  path: '/purchase-business',
  title: '采购管理',
  icon: 'mdi-purse',
  access: '采购管理',

  children: [
    {
      title: '供应商管理',
      icon: 'mdi-account-group',
      group: '/supplier',
      children: [
        {
          path: '/supplier/list3',
          name: 'supplier-main-list3',
          component: () =>
            import('@/views/common-business/supplier/supplier-main-list'),
          meta: {
            title: '合格供应商',
            access: '供应商列表:列表',
            status: '3',
          },
        },
        {
          path: '/supplier/list2',
          name: 'supplier-main-list2',
          component: () =>
            import('@/views/common-business/supplier/supplier-main-list'),
          meta: {
            title: '临时供应商',
            access: '供应商列表:列表',
            status: '2',
          },
        },
        {
          path: '/supplier/list1',
          name: 'supplier-main-list1',
          component: () =>
            import('@/views/common-business/supplier/supplier-main-list'),
          meta: {
            title: '应急供应商',
            access: '供应商列表:列表',
            status: '1',
          },
        },
        {
          path: '/supplier/list4',
          name: 'supplier-main-list4',
          component: () =>
            import('@/views/common-business/supplier/supplier-main-list'),
          meta: {
            title: '慎用供应商',
            access: '供应商列表:列表',
            status: '4',
          },
        },
        {
          path: '/supplier/list5',
          name: 'supplier-main-list5',
          component: () =>
            import('@/views/common-business/supplier/supplier-main-list'),
          meta: {
            title: '黑名单供应商',
            access: '供应商列表:列表',
            status: '5',
          },
        },
        {
          path: '/supplier/detail/:id',
          name: 'supplier-detail',
          component: () =>
            import('@/views/common-business/supplier/supplier-detail'),
          meta: {
            title: '供应商详情',
            access: '供应商列表:列表',
            notShowInNav: true,
          },
        },
        {
          path: '/purchase-business/supplier-in-list',
          name: 'supplier-in-list',
          component: () => import('@/views/purchase-business/supplier-in-list'),
          meta: {
            title: '合格供应商准入',
            access: '供应商准入:列表',
          },
        },
        {
          path: '/purchase-business/supplier-in-detail/:id',
          name: 'supplier-in-detail',
          component: () =>
            import('@/views/purchase-business/supplier-in-detail'),
          meta: {
            title: '合格供应商准入',
            access: '供应商准入:列表',
            notShowInNav: true,
          },
        },
        {
          path: '/purchase-business/supplier-in-list1',
          name: 'supplier-in-list1',
          meta: {
            title: '临时转合格供应商',
            access: '供应商准入:列表',
          },
        },
        // {
        //   path: '/purchase-business/supplier-in-list2',
        //   name: 'supplier-in-list2',
        //   meta: {
        //     title: '合格供应商评审',
        //     access: '供应商准入:列表',
        //   },
        // },
        {
          path: '/purchase-business/supplier-in-list3',
          name: 'supplier-in-list3',
          meta: {
            title: '合格供应商复审',
            access: '供应商准入:列表',
          },
        },
        {
          path: '/purchase-business/supplier-in-list4',
          name: 'supplier-in-list4',
          meta: {
            title: '临时供应商准入',
            access: '供应商准入:列表',
          },
        },
        {
          path: '/purchase-business/supplier-in-list5',
          name: 'supplier-in-list5',
          meta: {
            title: '警告与奖励',
            access: '供应商准入:列表',
          },
        },
        {
          path: '/purchase-business/supplier-in-list6',
          name: 'supplier-in-list6',
          meta: {
            title: '慎用',
            access: '供应商准入:列表',
          },
        },
        {
          path: '/purchase-business/supplier-in-list7',
          name: 'supplier-in-list7',
          meta: {
            title: '临时转不合格供应商',
            access: '供应商准入:列表',
          },
        },
        {
          path: '/purchase-business/supplier-in-list8',
          name: 'supplier-in-list8',
          meta: {
            title: '合格转不合格供应商',
            access: '供应商准入:列表',
          },
        },
        {
          path: '/supplier/supplier-assess/list',
          name: 'supplier-assess-list',
          component: () =>
            import(
              '@/views/purchase-business/supplier-assess/supplier-assess-list'
            ),
          meta: {
            title: '供应商合同评审',
            access: '供应商评审:列表',
          },
        },
        {
          path: '/supplier/supplier-assess/supplier-assess-detail/:id',
          name: 'supplier-assess-detail',
          component: () =>
            import(
              '@/views/purchase-business/supplier-assess/supplier-assess-detail'
            ),
          meta: {
            title: '供应商合同评审详情',
            access: '供应商评审:列表',
            notShowInNav: true,
          },
        },
        {
          path: '/supplier/list0',
          name: 'supplier-main-list0',
          component: () =>
            import('@/views/common-business/supplier/supplier-main-list'),
          meta: {
            title: '市场业务供应商',
            access: '供应商列表:列表',
            status: '0',
          },
        },
        // {
        //   path: '/supplier/supplier-assess/supplier-assess-detail-item/:id',
        //   name: 'supplier-assess-detail-item',
        //   component: () =>
        //     import(
        //       '@/views/purchase-business/supplier-assess/private/supplier-assess-detail-item'
        //     ),
        //   meta: {
        //     title: '供应商评审子表详情',
        //     access: '供应商评审:列表',
        //     notShowInNav: true,
        //   },
        // },
      ],
    },
    {
      title: '通讯费管理',
      icon: 'mdi-account-group',
      group: '/communication-fee',
      children: [
        {
          path: '/purchase-business/communication-fee/list',
          name: 'communication-fee-list',
          component: () =>
            import(
              '@/views/purchase-business/communication-fee/communication-fee-list'
            ),
          meta: {
            title: '合同管理',
            access: '通讯费合同:列表',
          },
        },
        {
          path: '/purchase-business/communication-fee/detail/:id',
          name: 'communication-fee-detail',
          component: () =>
            import(
              '@/views/purchase-business/communication-fee/communication-fee-detail'
            ),
          meta: {
            title: '合同管理',
            access: '通讯费合同:列表',
            notShowInNav: true,
          },
        },
        {
          path: '/purchase-business/communication-fee/network-malfunction-list',
          name: 'network-malfunction-list',
          component: () =>
            import(
              '@/views/purchase-business/communication-fee/network-malfunction-list'
            ),
          meta: {
            title: '网络故障',
            access: '网络故障:列表',
          },
        },
        {
          path: '/purchase-business/communication-fee/network-malfunction-detail/:id',
          name: 'network-malfunction-detail',
          component: () =>
            import(
              '@/views/purchase-business/communication-fee/network-malfunction-detail'
            ),
          meta: {
            title: '网络故障详情',
            access: '网络故障:列表',
            notShowInNav: true,
          },
        },
        {
          path: '/purchase-business/communication-fee/communication-fee-pay/list',
          name: 'communication-fee-pay-list',
          component: () =>
            import(
              '@/views/purchase-business/communication-fee/communication-fee-pay-list'
            ),
          meta: {
            title: '通讯费订单',
            access: '通讯费付款:列表',
          },
        },
        {
          path: '/purchase-business/communication-fee/communication-fee-pay-detail/:id',
          name: 'communication-fee-pay-detail',
          component: () =>
            import(
              '@/views/purchase-business/communication-fee/communication-fee-pay-detail'
            ),
          meta: {
            title: '通讯费订单',
            access: '通讯费付款:列表',
            notShowInNav: true,
          },
        },
        // {
        //   path: '/supplier/supplier-assess/supplier-assess-detail-item/:id',
        //   name: 'supplier-assess-detail-item',
        //   component: () =>
        //     import(
        //       '@/views/purchase-business/supplier-assess/private/supplier-assess-detail-item'
        //     ),
        //   meta: {
        //     title: '供应商评审子表详情',
        //     access: '供应商评审:列表',
        //     notShowInNav: true,
        //   },
        // },
      ],
    },
    {
      title: '消防救生检验管理',
      icon: 'mdi-account-group',
      group: '/fire-lifesave-inspection',
      children: [
        {
          path: '/purchase-business/fire-lifesave-inspection/list',
          name: 'fire-lifesave-inspection-contract-list',
          component: () =>
            import(
              '@/views/purchase-business/fire-lifesave-inspection/fire-lifesave-inspection-contract-list'
            ),
          meta: {
            title: '检验合同',
            access: '消防救生检验合同:列表',
          },
        },
        {
          path: '/purchase-business/fire-lifesave-inspection/detail/:id',
          name: 'fire-lifesave-inspection-contract-detail',
          component: () =>
            import(
              '@/views/purchase-business/fire-lifesave-inspection/fire-lifesave-inspection-contract-detail'
            ),
          meta: {
            title: '检验合同',
            access: '消防救生检验合同:列表',
            notShowInNav: true,
          },
        },
        {
          path: '/purchase-business/fire-lifesave-inspection-ship-contract/list',
          name: 'fire-lifesave-inspection-ship-contract-list',
          component: () =>
            import(
              '@/views/purchase-business/fire-lifesave-inspection/fire-lifesave-inspection-ship-contract/fire-lifesave-inspection-ship-contract-list'
            ),
          meta: {
            title: '单船合同',
            access: '消防救生检验单船合同:列表',
          },
        },
        {
          path: '/purchase-business/fire-lifesave-inspection-ship-contract/detail/:id',
          name: 'fire-lifesave-inspection-ship-contract-detail',
          component: () =>
            import(
              '@/views/purchase-business/fire-lifesave-inspection/fire-lifesave-inspection-ship-contract/fire-lifesave-inspection-ship-contract-detail'
            ),
          meta: {
            title: '单船合同',
            access: '消防救生检验单船合同:列表',
            notShowInNav: true,
          },
        },
      ],
    },
    {
      title: '检验与审核管理',
      icon: 'mdi-account-group',
      group: '/survery-audit',
      children: [
        {
          path: '/purchase-business/survery-audit/list',
          name: 'survery-audit-contract-list',
          component: () =>
            import(
              '@/views/purchase-business/survery-audit/survery-audit-contract-list'
            ),
          meta: {
            title: '检验与审核合同',
            access: '检验与审核合同:列表',
          },
        },
        {
          path: '/purchase-business/survery-audit/detail/:id',
          name: 'survery-audit-contract-detail',
          component: () =>
            import(
              '@/views/purchase-business/survery-audit/survery-audit-contract-detail'
            ),
          meta: {
            title: '检验与审核合同详情',
            access: '检验与审核合同:列表',
            notShowInNav: true,
          },
        },
        {
          path: '/purchase-business/survery-audit-ship-contract/list',
          name: 'survery-audit-ship-contract-list',
          component: () =>
            import(
              '@/views/purchase-business/survery-audit/survery-audit-ship-contract/survery-audit-ship-contract-list'
            ),
          meta: {
            title: '检验与审核单船合同',
            access: '检验与审核单船合同:列表',
          },
        },
        {
          path: '/purchase-business/survery-audit-ship-contract/detail/:id',
          name: 'survery-audit-ship-contract-detail',
          component: () =>
            import(
              '@/views/purchase-business/survery-audit/survery-audit-ship-contract/survery-audit-ship-contract-detail'
            ),
          meta: {
            title: '检验与审核船舶合同详情',
            access: '检验与审核单船合同:列表',
            notShowInNav: true,
          },
        },
        {
          path: '/purchase-business/survery-audit-ship-contract-order/list',
          name: 'survery-audit-ship-contract-order-list',
          component: () =>
            import(
              '@/views/purchase-business/survery-audit/survery-audit-ship-contract-order/survery-audit-ship-contract-order-list'
            ),
          meta: {
            title: '检验与审核单船合同订单',
            access: '检验与审核单船合同订单:列表',
          },
        },
        {
          path: '/purchase-business/survery-audit-ship-contract-order/detail/:id',
          name: 'survery-audit-ship-contract-order-detail',
          component: () =>
            import(
              '@/views/purchase-business/survery-audit/survery-audit-ship-contract-order/survery-audit-ship-contract-order-detail'
            ),
          meta: {
            title: '检验与审核船舶合同订单详情',
            access: '检验与审核单船合同订单:列表',
            notShowInNav: true,
          },
        },
      ],
    },
    {
      title: '通导检验管理',
      icon: 'mdi-account-group',
      group: '/communication-audit',
      children: [
        {
          path: '/purchase-business/communication-audit/list',
          name: 'communication-audit-contract-list',
          component: () =>
            import(
              '@/views/purchase-business/communication-audit/communication-audit-contract-list'
            ),
          meta: {
            title: '通导检验年度合同',
            access: '通导检验年度合同:列表',
          },
        },
        {
          path: '/purchase-business/communication-audit/detail/:id',
          name: 'communication-audit-contract-detail',
          component: () =>
            import(
              '@/views/purchase-business/communication-audit/communication-audit-contract-detail'
            ),
          meta: {
            title: '通导检验年度合同详情',
            access: '通导检验年度合同:列表',
            notShowInNav: true,
          },
        },
        // {
        //   path: '/purchase-business/survery-audit-ship-contract/list',
        //   name: 'survery-audit-ship-contract-list',
        //   component: () =>
        //     import(
        //       '@/views/purchase-business/survery-audit/survery-audit-ship-contract/survery-audit-ship-contract-list'
        //     ),
        //   meta: {
        //     title: '检验与审核单船合同',
        //     access: '检验与审核单船合同:列表',
        //   },
        // },
        // {
        //   path: '/purchase-business/survery-audit-ship-contract/detail/:id',
        //   name: 'survery-audit-ship-contract-detail',
        //   component: () =>
        //     import(
        //       '@/views/purchase-business/survery-audit/survery-audit-ship-contract/survery-audit-ship-contract-detail'
        //     ),
        //   meta: {
        //     title: '检验与审核船舶合同详情',
        //     access: '检验与审核单船合同:列表',
        //     notShowInNav: true,
        //   },
        // },
        // {
        //   path: '/purchase-business/survery-audit-ship-contract-order/list',
        //   name: 'survery-audit-ship-contract-order-list',
        //   component: () =>
        //     import(
        //       '@/views/purchase-business/survery-audit/survery-audit-ship-contract-order/survery-audit-ship-contract-order-list'
        //     ),
        //   meta: {
        //     title: '检验与审核单船合同订单',
        //     access: '检验与审核单船合同订单:列表',
        //   },
        // },
        // {
        //   path: '/purchase-business/survery-audit-ship-contract-order/detail/:id',
        //   name: 'survery-audit-ship-contract-order-detail',
        //   component: () =>
        //     import(
        //       '@/views/purchase-business/survery-audit/survery-audit-ship-contract-order/survery-audit-ship-contract-order-detail'
        //     ),
        //   meta: {
        //     title: '检验与审核船舶合同订单详情',
        //     access: '检验与审核单船合同订单:列表',
        //     notShowInNav: true,
        //   },
        // },
      ],
    },
    {
      title: '物资采购',
      icon: 'mdi-ferry',
      group: /spare-parts|repair-manage/,
      children: [
        {
          path: '/spare-parts/enquiry-list',
          name: 'spare-enquiry-list',
          component: () =>
            import(
              '@/views/maritime-maintence/spare-part/enquiry/spare-enquiry-list'
            ),
          meta: {
            title: '备件询价',
            access: '备件询价',
          },
        },
        {
          path: '/spare-parts/enquiry-detail/:id',
          name: 'spare-enquiry-detail',
          component: () =>
            import(
              '@/views/maritime-maintence/spare-part/enquiry/spare-enquiry-detail'
            ),
          meta: {
            title: '备件询价详情',
            access: '备件询价',
            notShowInNav: true,
          },
        },
        {
          path: '/lub-oil/soil-enquiry/list',
          name: 'soil-enquiry-list',
          component: () =>
            import(
              '@/views/maritime-maintence/slide-oil/enquiry/soil-enquiry-list'
            ),
          meta: {
            title: '滑油询价',
            access: '滑油询价',
          },
        },
        {
          path: '/lub-oil/soil-enquiry/detail/:id',
          name: 'soil-enquiry-detail',
          component: () =>
            import(
              '@/views/maritime-maintence/slide-oil/enquiry/soil-enquiry-detail'
            ),
          meta: {
            title: '滑油询价-详情',
            access: '滑油询价',
            notShowInNav: true,
          },
        },
        // {
        //   path: '/lub-oil/union-price-list',
        //   name: 'soil-union-price-list',
        //   component: () =>
        //     import(
        //       '@/views/maritime-maintence/slide-oil/union-price/union-price-list'
        //     ),
        //   meta: {
        //     title: '滑油批量报价',
        //     access: '滑油批量报价',
        //   },
        // },
        {
          path: '/materials/materials-enquiry/list',
          name: 'materials-enquiry-list',
          component: () =>
            import(
              '@/views/maritime-maintence/materials/enquiry/materials-enquiry-list'
            ),
          meta: {
            title: '物料询价',
            access: '物料询价',
          },
        },
        {
          path: '/materials/materials-enquiry/detail/:id',
          name: 'materials-enquiry-detail',
          component: () =>
            import(
              '@/views/maritime-maintence/materials/enquiry/materials-enquiry-detail'
            ),
          meta: {
            title: '物料询价-详情',
            notShowInNav: true,
            access: '物料询价',
          },
        },
        // {
        //   path: '/materials/materials-union-price/list',
        //   name: 'materials-union-price-list',
        //   component: () =>
        //     import(
        //       '@/views/maritime-maintence/materials/union-price/materials-union-price-list'
        //     ),
        //   meta: {
        //     title: '物料批量报价',
        //     access: '物料批量报价',
        //   },
        // },
        // {
        //   path: '/materials/materials-union-price/new',
        //   name: 'materials-union-price-detail',
        //   component: () =>
        //     import(
        //       '@/views/maritime-maintence/materials/union-price/materials-union-price-detail'
        //     ),
        //   meta: {
        //     title: '物料批量报价',
        //     notShowInNav: true,
        //     access: '物料批量报价',
        //   },
        // },
        {
          path: '/repair-manage/voyage-enquiry-list',
          name: 'voyage-enquiry-list',
          component: () =>
            import(
              '@/views/maritime-maintence/repair-manage/voyage-repair/enquiry/voyage-enquiry-list'
            ),
          meta: {
            title: '航修询价',
            access: '航修询价',
          },
        },
        {
          path: '/repair-manage/voyage-enquiry-detail/:id',
          name: 'voyage-enquiry-detail',
          component: () =>
            import(
              '@/views/maritime-maintence/repair-manage/voyage-repair/enquiry/voyage-enquiry-detail'
            ),
          meta: {
            title: '航修询价详情',
            notShowInNav: true,
            access: '航修询价',
          },
        },
      ],
    },
    {
      title: '备件集采',
      icon: 'mdi-dharmachakra',
      group: /special|component-batch-purchase/,
      children: [
        {
          path: '/special/purchase/component-standType-list',
          name: 'component-standType-list',
          component: () =>
            import(
              '@/views/purchase-business/component-batch-purchase/component-standType-list'
            ),
          meta: {
            title: '标准分类',
            access: '备件标准化分类:列表',
          },
        },
        {
          path: '/special/purchase/component-batch-purchase-list',
          name: 'component-batch-purchase-list',
          component: () =>
            import(
              '@/views/purchase-business/component-batch-purchase/component-batch-purchase-list'
            ),
          meta: {
            title: '机务集采',
            access: '备件专项集采:列表',
            type: '机务',
          },
        },
        {
          path: '/special/purchase/component-batch-purchase-detail/:id',
          name: 'component-batch-purchase-detail',
          component: () =>
            import(
              '@/views/purchase-business/component-batch-purchase/component-batch-purchase-detail'
            ),
          meta: {
            title: '备件专项集采详情',
            access: '备件专项集采:列表',
            notShowInNav: true,
            // type: '机务',
          },
        },
        {
          path: '/special/purchase/component-batch-purchase-listTD',
          name: 'component-batch-purchase-listTD',
          component: () =>
            import(
              '@/views/purchase-business/component-batch-purchase/component-batch-purchase-listTD'
            ),
          meta: {
            title: '通导集采',
            access: '通导专项集采:列表',
            type: '通导',
          },
        },
        // {
        //   path: '/special/purchase/component-batch-purchase-detail/:id',
        //   name: 'component-batch-purchase-detail',
        //   component: () =>
        //     import(
        //       '@/views/purchase-business/component-batch-purchase/component-batch-purchase-detail'
        //     ),
        //   meta: {
        //     title: '通导专项集采详情',
        //     access: '通导专项集采:列表',
        //     notShowInNav: true,
        //     type: '通导',
        //   },
        // },
      ],
    },
    {
      title: '设备集采',
      icon: 'mdi-dharmachakra',
      group: /special|engine-batch-purchase/,
      children: [
        {
          path: '/special/purchase/engine-batch-purchase-list',
          name: 'engine-batch-purchase-list',
          component: () =>
            import(
              '@/views/purchase-business/engine-batch-purchase/engine-batch-purchase-list'
            ),
          meta: {
            title: '机务集采',
            access: '备件专项集采:列表',
            type: '机务',
          },
        },
        {
          path: '/special/purchase/engine-batch-purchase-detail/:id',
          name: 'engine-batch-purchase-detail',
          component: () =>
            import(
              '@/views/purchase-business/engine-batch-purchase/engine-batch-purchase-detail'
            ),
          meta: {
            title: '设备专项集采详情',
            access: '备件专项集采:列表',
            notShowInNav: true,
            // type: '机务',
          },
        },
        {
          path: '/special/purchase/engine-batch-purchase-listTD',
          name: 'engine-batch-purchase-listTD',
          component: () =>
            import(
              '@/views/purchase-business/engine-batch-purchase/engine-batch-purchase-listTD'
            ),
          meta: {
            title: '通导集采',
            access: '通导专项集采:列表',
            type: '通导',
          },
        },
      ],
    },
    {
      title: '物料集采',
      icon: 'mdi-format-paint',
      group: '/procurement',
      children: [
        // {
        //   path: '/materials/materials-union-price/list',
        //   name: 'materials-union-price-list',
        //   component: () =>
        //     import(
        //       '@/views/maritime-maintence/materials/union-price/materials-union-price-list'
        //     ),
        //   meta: {
        //     title: '物料协议价',
        //     access: '物料协议价',
        //   },
        // },
        // {
        //   path: '/materials/materials-union-price/new',
        //   name: 'materials-union-price-detail',
        //   component: () =>
        //     import(
        //       '@/views/maritime-maintence/materials/union-price/materials-union-price-detail'
        //     ),
        //   meta: {
        //     title: '物料协议价',
        //     notShowInNav: true,
        //     access: '物料协议价',
        //   },
        // },
        {
          path: '/procurement/procurement-union-price/list05',
          name: 'procurement-union-price-list05',
          component: () =>
            import(
              '@/views/maritime-maintence/materials/union-price/materials-union-price-list'
            ),
          meta: {
            title: '物料协议价',
            access: '季度物料协议价',
            subjectId: '其他', //其他
          },
        },
        {
          path: '/procurement/purchase/material-batch-purchase-list',
          name: 'material-batch-purchase-list',
          component: () =>
            import(
              '@/views/purchase-business/material-batch-purchase/material-batch-purchase-list'
            ),
          meta: {
            title: '物料集采',
            access: '物料专项集采:列表',
          },
        },
        {
          path: '/procurement/purchase/material-batch-purchase-detail/:id',
          name: 'material-batch-purchase-detail',
          component: () =>
            import(
              '@/views/purchase-business/material-batch-purchase/material-batch-purchase-detail'
            ),
          meta: {
            title: '物料集采',
            access: '物料专项集采:列表',
            notShowInNav: true,
          },
        },
      ],
    },
    {
      title: '大宗集采',
      icon: 'mdi-water-sync',
      group: /lub-oil|materials|beijian/,
      children: [
        {
          path: '/lub-oil/union-price-list',
          name: 'soil-union-price-list',
          component: () =>
            import(
              '@/views/maritime-maintence/slide-oil/union-price/union-price-list'
            ),
          meta: {
            title: '滑油协议价',
            access: '滑油协议价',
          },
        },
        {
          path: '/lub-oil/union-price-new',
          name: 'soil-union-price-detail',
          component: () =>
            import(
              '@/views/maritime-maintence/slide-oil/union-price/union-price-detail'
            ),
          meta: {
            title: '滑油协议价',
            access: '滑油协议价',
            notShowInNav: true,
          },
        },
        {
          path: '/materials/materials-union-price/list01',
          name: 'materials-union-price-list01',
          component: () =>
            import(
              '@/views/maritime-maintence/materials/union-price/materials-union-price-list'
            ),
          meta: {
            title: '油漆协议价',
            access: '油漆协议价',
            subjectId: '1581991857076989953', //油漆费
          },
        },
        {
          path: '/materials/materials-union-price/list02',
          name: 'materials-union-price-list02',
          component: () =>
            import(
              '@/views/maritime-maintence/materials/union-price/materials-union-price-list'
            ),
          meta: {
            title: '化学品协议价',
            access: '化学品协议价', //后台权限相关
            subjectId: '1581991857064407043', //化学品
          },
        },
        {
          path: '/materials/materials-union-price/list03',
          name: 'materials-union-price-list03',
          component: () =>
            import(
              '@/views/maritime-maintence/materials/union-price/materials-union-price-list'
            ),
          meta: {
            title: '缆绳协议价',
            access: '缆绳协议价',
            subjectId: '1581991856967938050', //缆绳
          },
        },
        {
          path: '/materials/materials-union-price/list04',
          name: 'materials-union-price-list04',
          component: () =>
            import(
              '@/views/maritime-maintence/materials/union-price/materials-union-price-list'
            ),
          meta: {
            title: '绑扎件协议价',
            access: '绑扎件协议价',
            subjectId: '1581991857072795650', //绑扎件
          },
        },
        {
          path: '/beijian/union-price-list',
          name: 'union-price-list',
          component: () =>
            import(
              '@/views/maritime-maintence/spare-part/union-price/union-price-list'
            ),
          meta: {
            title: '锚锚链协议价',
            access: '锚和锚链协议价',
          },
        },
        {
          path: '/beijian/union-price-new',
          name: 'union-price-detail',
          component: () =>
            import(
              '@/views/maritime-maintence/spare-part/union-price/union-price-detail'
            ),
          meta: {
            title: '锚锚链协议价',
            notShowInNav: true,
            access: '锚和锚链协议价',
          },
        },
        // {
        //   path: '/materials/materials-union-price/list05',
        //   name: 'materials-union-price-list05',
        //   component: () =>
        //     import(
        //       '@/views/maritime-maintence/materials/union-price/materials-union-price-list'
        //     ),
        //   meta: {
        //     title: '其他物料协议价',
        //     access: '物料协议价',
        //     subjectId: '其他', //其他
        //   },
        // },
        {
          path: '/materials/materials-union-price/new',
          name: 'materials-union-price-detail',
          component: () =>
            import(
              '@/views/maritime-maintence/materials/union-price/materials-union-price-detail'
            ),
          meta: {
            title: '物料协议价',
            notShowInNav: true,
            access: '物料协议价',
          },
        },
        // {
        //   path: '/spare-parts/union-price-list',
        //   name: 'union-price-list',
        //   component: () =>
        //     import(
        //       '@/views/maritime-maintence/spare-part/union-price/union-price-list'
        //     ),
        //   meta: {
        //     title: '备件批量报价',
        //     access: '备件批量报价',
        //   },
        // },
        // {
        //   path: '/spare-parts/union-price-new',
        //   name: 'union-price-detail',
        //   component: () =>
        //     import(
        //       '@/views/maritime-maintence/spare-part/union-price/union-price-detail'
        //     ),
        //   meta: {
        //     title: '备件批量报价-详情',
        //     access: '备件批量报价',
        //     notShowInNav: true,
        //   },
        // },
        // group: /spare-parts|lub-oil|materials|repair-manage|special/,
      ],
    },
  ],
}
